import { render, staticRenderFns } from "./ChangeStatusSidebar.vue?vue&type=template&id=3f449838&"
import script from "./ChangeStatusSidebar.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusSidebar.vue?vue&type=style&index=0&id=3f449838&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports